export const Materials = () => {
  return (
    <iframe
      src="/osnovni-instrukcii.html"
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="Инструкции и материали"
    />
  );
}